<template >
  <div  style="height: 10vh;overflow: hidden">
    <el-form :model="formData"  label-width="120px" :disabled="disabled" style="margin-right: 20px">
      <el-row>
        <el-form-item label="模具编号：" style="width: 50%;" required>
          <el-select v-model="formData.mold_id" clearable >
            <el-option v-for="item in moldList" :key="item.value" :label="item.name" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="成本类型：" style="width: 50%;" required>
          <el-select v-model="formData.cost_type" clearable >
            <el-option v-for="item in costTypeList" :key="item.value" :label="item.name" :value="item.value"/>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="开始日期：" style="width: 50%;" required>
          <el-date-picker style="width:52%" value-format="YYYY-MM-DD" v-model="formData.start_date" @change="changeTime" clearable filterable/>
          <el-time-picker format="HH:mm" value-format="HH:mm"  style="width:46%;margin-left: 2%" v-model="formData.start_time"
                          clearable filterable @change="changeTime"/>
        </el-form-item>
        <el-form-item label="结束日期：" style="width: 50%;" required>
          <el-date-picker style="width:52%" value-format="YYYY-MM-DD" v-model="formData.end_date" @change="changeTime" clearable filterable/>
          <el-time-picker format="HH:mm" value-format="HH:mm"  style="width:46%;margin-left: 2%" v-model="formData.end_time"
                          clearable filterable @change="changeTime"/>
        </el-form-item>
      </el-row>
      <el-form-item label="时长(分钟)：" style="width: 50%;">
        <el-input style="width: 100%" v-model="formData.duration" :disabled="true" clearable/>
      </el-form-item>
      <el-form-item label="备注：">
        <el-input v-model="formData.remark" autosize type="textarea"></el-input>
      </el-form-item>
    </el-form>
    <el-row style="margin-left: 39px;" >
      <el-col :span="3">{{("组装图纸：")}}</el-col>
      <el-col :span="20"  v-if="componentParam !== 'mes_mold_manual_work_reporting_details'">
        <kf-file-upload v-model="formData.attachments" :init-file="fileList"
                        @fileChange="fileChange"
                        :limit="10" :showTotalCnt="true" :showSuccessCnt="true"></kf-file-upload>
      </el-col>
      <el-col :span="20" v-if="this.parentData.attachments && componentParam === 'mes_mold_manual_work_reporting_details'" v-for="item in this.parentData.attachments" :key="item.id" style="width: 100%;height: 100%">
        <el-button text  @click="startPage(item,this.parentData.attachments)" class="startPageClass" >{{ item.originalName }}</el-button>
        <el-button text  @click="downloadPage(item)" style="color: #00afff;justify-content: left">下载</el-button>
      </el-col>
    </el-row>
    <el-row v-if="componentParam !== 'mes_mold_manual_work_reporting_details'" justify="center" style="width: 95%;margin: 20px 0 0 0">
      <el-button type="primary" @click="submit">保存</el-button>
    </el-row>
  </div>
</template>

<script>

export default {
  name: "MmManualWorkReporting",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      formData:{},
      moldList:[],
      disabled: false,
      fileList: [],

    };
  },
  computed: {
    costTypeList() {
      return this.$store.getters['core/getDictList']('mes_mold_cost_type');
    },
  },
  mounted() {
    this.getMoldList()
    this.getFile()
    if (this.componentParam === 'mes_mold_manual_work_reporting_details'){
      this.disabled = true
    }
    if (this.componentParam !== 'mes_mold_manual_work_reporting_add'){
      this.formData = this.parentData
    }

  },

  methods: {
    //提交
    async submit() {
      if (!this.formData.mold_id) {
        this.$message.error("请选择模具编号！")
        return
      }
      if (!this.formData.cost_type) {
        this.$message.error("请选择成本类型！")
        return
      }
      if (!this.formData.start_date) {
        this.$message.error("请选择开始日期！")
        return
      }
      if (!this.formData.start_time) {
        this.$message.error("请选择开始时间！")
        return
      }
      if (!this.formData.end_date) {
        this.$message.error("请选择结束日期！")
        return
      }
      if (!this.formData.end_time) {
        this.$message.error("请选择结束时间！")
        return
      }
      if (this.componentParam === 'mes_mold_manual_work_reporting_add'){
        await this.$http('mesMoldMmCreateService.createManualWorkReporting', this.formData)
      }else if (this.componentParam === 'mes_mold_manual_work_reporting_edit'){
        await this.$http('mesMoldMmCreateService.updateManualWorkReporting', this.formData)
      }
      this.$message.success("保存成功！");
      this.$fn.closeWindow();
      this.$fn.search();
    },
    async changeTime() {
      if (this.formData.start_date && this.formData.end_date && this.formData.start_time  && this.formData.end_time){
        if (this.formData.start_date >=  this.formData.end_date){
          if (this.formData.start_date >  this.formData.end_date){
            this.$message.error("开始日期不能大于结束日期！")
            return
          }else {
            if (this.formData.start_time > this.formData.end_time){
              this.$message.error("开始时间不能大于结束时间！")
              return
            }
          }
        }
        this.formData.duration = await this.$http('mesMoldMmCreateService.getMinutes', this.formData)
      }
    },
    async getMoldList() {
      this.moldList = await this.$http('mesMoldDsService.getMoldAll')
    },
    async getFile() {
      if (this.parentData.attachments) {
        this.parentData.attachments = await this.$http('mesMoldMmDsService.getFileList', {attachments:this.parentData.attachments})
        this.fileList =  this.parentData.attachments
      }
    },
    async fileChange(ids) {
      if (ids.length <= 0) {
        // this.formData.attachments = []
        return
      }

      this.formData.attachments = ids;
    },

    startPage(item, itemData) {
      let windowObj = {}
      windowObj.icon = "system/view";
      windowObj.component = "prc/PrcPdf";
      windowObj.name = item.originalName.substring(0, item.originalName.length - 4);
      windowObj.parentData = {sys_file: item, itemData: itemData};
      windowObj.height = 800 || this.$store.getters['core/getGlobalWindowHeight']
      windowObj.width = 1350 || this.$store.getters['core/getGlobalWindowWidth']

      this.$store.dispatch('core/openWindow', windowObj)
    },
    //下载文件
    downloadPage(item) {
      let url = item?.url;
      if (!url) {
        return
      }
      let name = item.name

      const a = document.createElement('a')

      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + (url.startsWith('/') ? '' : '/') + url;
      }
      // 这里是将url转成blob地址，
      fetch(url).then(res => res.blob()).then(blob => { // 将链接地址字符内容转变成blob地址
        a.href = URL.createObjectURL(blob)
        a.download = name || '' // 下载文件的名字
        document.body.appendChild(a)
        a.click()

        //在资源下载完成后 清除 占用的缓存资源
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      })
    },

  },
}
</script>

<style lang="less" scoped>
.graph_container {
  background-color: white;
}
.startPageClass {
  color: #00afff;
  justify-content: left
}

</style>